const S3 = require('aws-sdk/clients/s3');

const s3 = new S3({
  accessKeyId: process.env.MIX_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.MIX_AWS_SECRET_ACCESS_KEY,
  region: process.env.MIX_AWS_DEFAULT_REGION,
  correctClockSkew: true
});

function upload(fileContent, fileName, publicFile, documentBucket) {

  const params = {
    ACL: publicFile ? 'public-read' : 'private',
    Bucket: selectBucket(documentBucket, publicFile),
    Key: fileName,
    Body: fileContent,
  };

  return new Promise((resolve, reject) => {
    s3.upload(params, function(err, data) {
      if (err) {
        reject(err);
      }

      if (data) {
        resolve(data);
      } else {
        reject();
      }
    });
  })
}

function selectBucket(documentBucket, isPublic) {
  if (isPublic) {
    return process.env.MIX_AWS_PUBLIC_BUCKET
  }

  if (documentBucket) {
    return process.env.MIX_AWS_DOCUMENTS_BUCKET
  }

  return process.env.MIX_AWS_BUCKET
}

module.exports = { upload }
